module.exports = __webpack_public_path__ + "img/promotion_12_03.jpg";